import { IBaseChartData, ICombinedBaseChartData } from '@app/api/interfaces/chart-data/base-chart-data';

export function convertChartDataInArray<IChartPointData, ICommonChartPointData extends object>(
  data: IBaseChartData<IChartPointData, ICommonChartPointData>
): ICombinedBaseChartData<IChartPointData, ICommonChartPointData>[] {
  const { values, ...commonData } = data;

  return values.map(baseChartPointData => ({ ...baseChartPointData, ...(commonData as ICommonChartPointData) }));
}
